import { useState, useContext } from "react";
import LocContext from "../context/locContext";
import axios from "axios";
import ClientNavbar from "../layout/ClientNavbar";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";

export default function LoanApplication() {
  const { userData } = useContext(LocContext);
  const id = userData?.id;
  const navigate = useNavigate();

  const [data, setData] = useState({
    user_id: id,
    loan_category: "Secured",
    loan_type: "",
    loan_amount: "",
    market_value: "",
    business_activity: "",
    profession: "",
    industry: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // simple validation
      if (
        !data.loan_category ||
        !data.loan_type ||
        !data.loan_amount ||
        !data.market_value ||
        !data.business_activity ||
        !data.profession ||
        !data.industry
      ) {
        Swal.fire({
          title: "Please fill all required fields",
          icon: "warning",
        });
        return;
      }

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/loan-application/store`,
        data,
      );
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Loan Application Submitted Successfully",
          text: `Application Code: ${res.data.application_code}`,
          timer: 2000,
        }).then(() => {
          navigate("/getcreatescore"); // redirect wherever you want
        });
      } else {
        Swal.fire({
          title: "Application Failed",
          icon: "error",
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        title: "Server Error",
        icon: "error",
      });
    }
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
          <form  onSubmit={handleSubmit}>

            <div className="card shadow-sm p-4 mb-4">
            <h3 className="text-primary mb-2">Loan Application</h3>
            {/* Breadcrumb with custom link color */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb mb-3">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/clientloan">Apply For Loan</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Loan Application
                </li>
              </ol>
            </nav>
            </div>

            {/* Loan Security Type */}
            <div className="card shadow-sm p-4 mb-4">
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label d-block">
                  <strong>Loan Security Type</strong>
                </label>

                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="loan_category"
                    value="Secured"
                    checked={data.loan_category === "Secured"}
                    onChange={handleInputChange}
                  />
                  <label className="form-check-label">Secured Loan</label>
                </div>

                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="loan_category"
                    value="Unsecured"
                    checked={data.loan_category === "Unsecured"}
                    onChange={handleInputChange}
                  />
                  <label className="form-check-label">Unsecured Loan</label>
                </div>
              </div>
            </div>

            {/* Loan Fields */}
            <div className="row g-3">
              {/* Loan Type */}
              <div className="col-md-4">
                <label className="form-label">
                  <strong>Loan Type</strong>
                </label>
                <select
                  name="loan_type"
                  className="form-select"
                  onChange={handleInputChange}
                >
                  <option value="">Select Loan Type</option>
                  <option value="Home Loan">Home Loan</option>
                  <option value="MSME Loan">MSME Loan</option>
                  <option value="Personal Loan">Personal Loan</option>
                </select>
              </div>

              {/* Loan Amount */}
              <div className="col-md-4">
                <label className="form-label">
                  <strong>Loan Amount</strong>
                </label>
                <input
                  type="number"
                  name="loan_amount"
                  className="form-control"
                  onChange={handleInputChange}
                  placeholder="Enter loan amount"
                />
              </div>

              {/* Approx Market Value */}
              <div className="col-md-4">
                <label className="form-label">
                  <strong>Approx Market Value</strong>
                </label>
                <input
                  type="number"
                  name="market_value"
                  className="form-control"
                  onChange={handleInputChange}
                  placeholder="Enter approx market value"
                />
              </div>

              {/* Nature of Business Activity */}
              <div className="col-md-4">
                <label className="form-label">
                  <strong>Nature of Business Activity</strong>
                </label>
                <select
                  name="business_activity"
                  className="form-select"
                  onChange={handleInputChange}
                >
                  <option value="">Select Nature</option>
                  <option value="Manufacturing">Manufacturing</option>
                  <option value="Services">Services</option>
                  <option value="Trading">Trading</option>
                </select>
              </div>

              {/* Profession */}
              <div className="col-md-4">
                <label className="form-label">
                  <strong>Profession</strong>
                </label>
                <select
                  name="profession"
                  className="form-select"
                  onChange={handleInputChange}
                >
                  <option value="">Select Profession</option>
                  <option value="Doctor">Doctor</option>
                  <option value="Engineer">Engineer</option>
                  <option value="Teacher">Teacher</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              {/* Industry */}
              <div className="col-md-4">
                <label className="form-label">
                  <strong>Industry</strong>
                </label>
                <select
                  name="industry"
                  className="form-select"
                  onChange={handleInputChange}
                >
                  <option value="">Select Industry</option>
                  <option value="IT">IT</option>
                  <option value="Healthcare">Healthcare</option>
                  <option value="Manufacturing">Manufacturing</option>
                  <option value="Finance">Finance</option>
                </select>
              </div>
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-end mt-4 gap-3">
              <button
                type="button"
                className="btn btn-primary px-4"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-primary px-4">
                Next
              </button>
            </div>
            </div>
          </form>
        </div>
    </>
  );
}
